var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamsLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-0{fill:none;}\n            .cls-1{fill:#fff;}\n            .cls-2{fill:#efeff0;}\n            .cls-3{fill:#d2ddfa;}\n            .cls-4{fill:#b4c6fa;}\n            .cls-5{fill:#4a77f6;}\n            .cls-6{fill:#668fff;}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M14,14.18a4.15,4.15,0,0,0,2.3.84c2.39,0,5.55-3.39,5.55-6.44a5.53,5.53,0,0,0-5.55-5.52h-.44A8.47,8.47,0,0,1,17,7.34,10.73,10.73,0,0,1,14,14.18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M8.76,15c2.79,0,6.49-4,6.49-7.52a6.49,6.49,0,0,0-13,0C2.28,11,6,15,8.76,15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M15.36,17a1.57,1.57,0,0,0-.15-.43,2,2,0,0,0-2.7-.9l-.74.37a6.78,6.78,0,0,1-6,0L5,15.66a1.63,1.63,0,0,0-.44-.15A2,2,0,0,0,2.16,17L1,21.77A1,1,0,0,0,1,22a1,1,0,0,0,1,1H15.52a.85.85,0,0,0,.23,0,1,1,0,0,0,.75-1.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M23,21.77l-1.12-4.71a2.23,2.23,0,0,0-.16-.43A2,2,0,0,0,19,15.74l-.75.37a6.9,6.9,0,0,1-1.31.49L18,21.5a2,2,0,0,1-.17,1.35l-.09.15H22l.23,0A1,1,0,0,0,23,21.77Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsLight);
export default __webpack_public_path__ + "static/media/teams-light.89bf06be053e49bb4fa7773d3ea641aa.svg";
export { ForwardRef as ReactComponent };